const resource = {
  api: "/api/v1",
};

module.exports = resource;
